import React from 'react'
import { inject, observer } from 'mobx-react'
import Name from '../common/Name'
import Rename from '../common/Rename'
import DeleteItemPrompt from 'components/tools/item/DeleteItemPrompt'
import { trackValue } from 'utils.js'
import { withTranslation } from 'react-i18next'
import ProBadge from 'components/common/ProBadge'
import { startProCheckout } from '../../../proCheckout'
import ExportTargetGroup from './ExportTargetGroup'
import { HugeiconsIcon } from '@hugeicons/react'
import ColorButton from '../common/ColorButton'
import {
  PencilEdit01Icon,
  CenterFocusIcon,
  Share01Icon,
  FileSpreadsheetIcon,
  Delete02Icon
} from '@hugeicons/core-free-icons'

import RenameTooltip from 'components/common/tooltips/RenameTooltip'

const OwnedTargetGroup = ({ group, uiStore, dataStore, selectionStore, t }) => {
  return (
    <div className='owned-geopolygon' key={group.pk}>
      {
        group.renameForm.active
          ? (
            <Rename
              label={t('TARGET_GROUP.TARGET_GROUP')}
              {...trackValue(group.renameForm, 'name')}
              error={group.error}
              clearError={() => (group.error = null)}
              onSubmit={() => {
                uiStore.renameTargetGroup(group, group.renameForm.name)
                if (!group.error) {
                  group.endRename()
                }
              }}
              onCancel={() => group.endRename()}
            />
            )
          : (
            <Name
              label={t('TARGET_GROUP.TARGET_GROUP')}
              onClick={() => group.startRename()}
              key='input'
              name={group.name}
            />
            )
      }
      <section className='owned-geopolygon__list'>
        <button
          className={`rename ${uiStore.user && uiStore.user.type === 'starter' ? 'item-controls__disabled' : ''}`}
          onClick={(e) => {
            e.stopPropagation()
            if (uiStore.user && uiStore.user.type === 'starter') {
              startProCheckout({ uiStore, t })
              return
            }
            uiStore.openClickTooltip({
              style: {
                width: 340
              },
              position: 'right-start',
              selector: '.tools.popup-menu',
              text: (
                <RenameTooltip
                  title={t('GLOBAL.RENAME_FOLDER', { defaultValue: 'Rename folder' })}
                  label={t('GLOBAL.FOLDER_NAME', { defaultValue: 'Folder name' })}
                  initialValue={group.name}
                  onSubmit={(newName) => {
                    uiStore.renameTargetGroup(group, newName)
                    uiStore.hideClickTooltip()
                  }}
                  onClose={() => {
                    uiStore.hideClickTooltip()
                  }}
                />
              )
            })
          }}
        >
          <HugeiconsIcon icon={PencilEdit01Icon} size={18} className='popup-menu__icon' />
          <span>{t('GLOBAL.RENAME')}</span>
          {uiStore.user && uiStore.user.type === 'starter' &&
          <ProBadge className='map-settings__pro text-small'>{t('GLOBAL.PRO')}</ProBadge>}
        </button>
        <ColorButton item={group} />
        <button onClick={e => {
          e.currentTarget.blur()
          uiStore.setBoundsToItem(group)
        }}
        >
          <HugeiconsIcon icon={CenterFocusIcon} size={18} className='popup-menu__icon' />
          <span>{t('GLOBAL.FIT_REGION')}</span>
        </button>
        {
          uiStore.user.canShare
            ? (
              <button onClick={e => {
                e.currentTarget.blur()
                dataStore.toggleTargetGroupShare(group)
              }}
              >
                <HugeiconsIcon icon={Share01Icon} size={18} className='popup-menu__icon' />
                <span>{
                  group['share_type'] !== 'none'
                    ? t('GLOBAL.UNSHARE')
                    : t('GLOBAL.SHARE')
                }
                </span>
              </button>
              )
            : null
        }
        <button
          key='btn-excel'
          className={uiStore.user && uiStore.user.type === 'starter' ? 'item-controls__disabled' : ''}
          onClick={() => {
            if (uiStore.user && uiStore.user.type === 'starter') {
              startProCheckout({ uiStore, t })
              return
            }
            group.analysis.exportExcel(group.name)
          }}
        >
          <HugeiconsIcon icon={FileSpreadsheetIcon} size={18} className='popup-menu__icon' />
          <span>{t('GLOBAL.EXCEL_EXPORT')}</span>
          {uiStore.user && uiStore.user.type === 'starter' &&
            <ProBadge className='map-settings__pro text-small'>{t('GLOBAL.PRO')}</ProBadge>}
        </button>
        <ExportTargetGroup lgIcon disabled={uiStore.user && uiStore.user.type === 'starter'} group={group} />
        <button
          className='delete'
          onClick={(e) => {
            e.stopPropagation()
            uiStore.openDeletePrompt({
              style: {
                width: 340
              },
              position: 'right-start',
              selector: '.tools.popup-menu',
              text: (
                <DeleteItemPrompt
                  item={group}
                  itemType='targetGroup'
                  title={t('GLOBAL.DELETE_TARGET_GROUP_Q', { defaultValue: 'Delete target group?' })}
                  itemName={group.name}
                  description={t('GLOBAL.DELETE_TARGET_GROUP_DESC', { defaultValue: 'This target group and all saved items inside it will be permanently removed.' })}
                  onSubmit={() => uiStore.deleteTargetGroup(group)}
                />
              )
            })
          }}
        >
          <HugeiconsIcon icon={Delete02Icon} size={18} className='popup-menu__icon' />
          <span>{t('GLOBAL.DELETE')}</span>
        </button>
      </section>
    </div>
  )
}

export default withTranslation()(inject('selectionStore', 'uiStore', 'dataStore')(observer(OwnedTargetGroup)))
